import { Center, Flex, Text } from '@chakra-ui/react';
import { Drawer } from '@halo/ui-react';
import { BackIcon, CloseIcon } from '@halo/ui-chat-react';
import { memo } from 'react';

export interface ContentDrawerProps {
  title?: string;
  children?: React.ReactNode;
  trigger?: React.ReactNode;
  disabled?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  closeAllClick?: () => void;
}

export const ContentDrawer = memo(function ContentDrawer({
  title,
  children,
  trigger,
  open,
  onOpenChange,
  disabled,
  closeAllClick,
}: ContentDrawerProps) {
  return (
    <Drawer.Root open={open} onOpenChange={(e) => onOpenChange?.(e.open)} lazyMount unmountOnExit>
      <Drawer.Trigger asChild>{trigger}</Drawer.Trigger>
      <Drawer.Positioner pos="absolute" boxSize="full" hidden={disabled}>
        <Drawer.Content bg="bg.subtle" w="456px" flex="0 0 auto" maxW="none">
          <Drawer.Header justifyContent="space-between" py="2.5" px="4" pt="5" color="fg">
            <Drawer.CloseTrigger asChild pos="relative" left="0" top="0">
              <Flex gap="2" alignItems="center" fontSize="md" cursor="pointer">
                <Center>
                  <BackIcon />
                </Center>
                <Text fontWeight="semibold">{title}</Text>
              </Flex>
            </Drawer.CloseTrigger>
            <Drawer.CloseTrigger
              asChild
              pos="relative"
              right="0"
              top="0"
              onClick={() => closeAllClick?.()}
            >
              <Center fontSize="md" cursor="pointer" color="fg.subtle">
                <CloseIcon />
              </Center>
            </Drawer.CloseTrigger>
          </Drawer.Header>
          <Drawer.Body px="4" py="2.5">
            {children}
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
});
